import * as S from '../components/styles';
import illustration from './illustration';

const Illustration = S.getIllustration(illustration);
export default () => {
  return (
    <S.Content>
      <S.Title>401</S.Title>
      <S.SubTitle>Authorization required</S.SubTitle>
      <S.Link to="/">Home</S.Link>
      <Illustration />
    </S.Content>
  );
};
